import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PrepaymentConfigPanel.html?raw';

import { SelectEntityDialogTypes } from "../../../../moreCore/_loadingHelpers/SelectEntityDialog";
import { VAM2types } from "../../../_loadingHelpers/VAMv2Types";
import _uiFrameMixin from '../../../../moreCore/UI/Container/uiFrame';
import _StatefulSection from '../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _GlobalSelectEntityDialogsMixin from '../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import lang from 'dojo/_base/lang';
import NumberInput from '../../../../moreCore/UI/NumberInput/NumberInput';
import HintBox from '../../../../moreCore/UI/HintBox/HintBox';
import DateInput from '../../../../moreCore/UI/DateInput/DateInput';

class PrepaymentConfigPanel extends compose(_StatefulSection, _uiFrameMixin, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private project: VAM2types.EvProjectEntity_Extended;
    private commdocType: VAM2types.CommdocTypes;
    private commdocAddress;

    private offerAmountInput: MdsLax<InstanceType<typeof NumberInput>>;
    private prelimDocInput: MdsLax<InstanceType<typeof HintBox>>;
    private datePaymentTargetInput: MdsLax<InstanceType<typeof DateInput>>;
    private prepaymentAmountInput: MdsLax<InstanceType<typeof NumberInput>>;


    setup(project: VAM2types.EvProjectEntity_Extended, commdocType: VAM2types.CommdocTypes, containerNode: HTMLDivElement) {
        if (!project) {
            console.error("No project provided");
            this.isValid();
            return;
        }
        else if (!commdocType) {
            console.error("No commdoc type provided");
            return;
        }

        this.project = project;
        this.commdocType = commdocType;
        this.prelimDocInput.addAdditionalRequestParameter("planningID", project.ID);
        this.prelimDocInput.addAdditionalRequestParameter("commdocType", commdocType);

        this._handleFeatureSections();

        this.setStartupState("ready");

        this.show("node", containerNode);
    }

    setCommdocAddress(commdocAddress) {
        this.prelimDocInput.addAdditionalRequestParameter("commdocAddress", commdocAddress);
        this.commdocAddress = commdocAddress;
    }

    private _onClickSEDButton(mode: string, event: MouseEvent) {
        let additionalData;

        switch (mode) {
            case "selectPrelimDoc":
                additionalData = {
                    planningID: this.project.ID,
                    commdocType: this.commdocType,
                    commdocAddress: this.commdocAddress
                }
                break;
        }

        this.openSelectEntityDialog(event, mode, lang.hitch(this, this._onSEDCallback), null, additionalData);
    }

    private _handleFeatureSections(): void {
        let canSelectPaymentTarget = this.hasFeature("CommdocConfigPanel/SelectPaymentTarget");
        this.hideNode(this.datePaymentTargetInput, !canSelectPaymentTarget);
        this.datePaymentTargetInput.setMandatory(canSelectPaymentTarget);
    }

    private _onSEDCallback(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<any>>) {
        if (!items || !items?.length) return;

            switch (mode) {
                case "selectPrelimDoc":
                    this.prelimDocInput.setValue(items[0].entry.data);
                    break;
            }
    }

    protected _onChanged(attribute: string, newValue: any) {
        switch (attribute) {
            case "percentage":
                var offerAmount = this.getAttributeValue("offerAmount");
                offerAmount = offerAmount ? offerAmount * newValue / 100 : 0;
                this.prepaymentAmountInput.setValue(offerAmount, true);
                break;
            case "prelimDoc":
                var newOfferAmount = newValue?.price_total_incl_VAT ? newValue?.price_total_incl_VAT : 0;
                this.setAttributeValue("offerAmount", newOfferAmount);
                break;
            case "offerAmount":
                var percentage = this.getAttributeValue("percentage");
                var newAmount = newValue ? newValue * percentage / 100 : 0;
                this.setAttributeValue("prepaymentAmount", newAmount);
                break;
            case "prepaymentAmount":
                var offerAmount = this.getAttributeValue("offerAmount");
                if (newValue > offerAmount) {
                    this.setAttributeValue("prepaymentAmount", 0);
                    return;
                }
                var newPercentage = offerAmount ? newValue / offerAmount * 100 : 0;
                this.setAttributeValue("percentage", newPercentage);
                break;
        }
        this.emit("changed", this.getChangedData());
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.SEDconfigCallfunction = "Webtool_API_CommdocConfigPanel_GetSEDConfig";

        this.prelimDocInput.addInlineButton(lang.hitch(this, this._onClickSEDButton, "selectPrelimDoc"));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PrepaymentConfigPanel);